
function showDropdown (sub_nav){
  sub_nav.stop( true, true ).slideDown()
}

function hideDropdown (sub_nav) {
  sub_nav.stop( true, true ).slideUp()
}

const init = () => {
  let nav = $('.shopping-bag__wrapper')
  let sub_nav = $('.mini-cart')

  nav.on('mouseenter touchstart', function(){
    showDropdown(sub_nav)
  })

  nav.on('mouseleave touchstart',function(event){
    hideDropdown(sub_nav)
  })

  jQuery(".search-trigger").on("click", function() {
    jQuery(".search-container").toggleClass("hidden");
  });

  jQuery(".search-trigger-mobile").on("click", function() {
    jQuery(".mobile-mega-menu").addClass("hidden");
    jQuery("body").removeClass("modal-active");
    jQuery(".search-container").toggleClass("hidden");
  });

  jQuery(".mobile-nav-top-item").on("click", function() {
    if (jQuery(this).hasClass("active")) {
      console.log("clicked same link");
      jQuery(this)
        .next()
        .removeClass("on");
      jQuery(this)
        .next()
        .addClass("hidden");
      jQuery(this).toggleClass("active");
      jQuery(this)
        .find("i")
        .toggleClass("fa-minus fa-plus");
    } else {
      // jQuery('.mobile-mega-menu').find(".active").toggleClass('hidden active')
      jQuery(".mobile-mega-menu")
        .find("i.fa-minus")
        .toggleClass("fa-minus fa-plus");
      jQuery(".mobile-mega-menu")
        .find(".on")
        .addClass("hidden");
      jQuery(".mobile-mega-menu")
        .find(".on")
        .removeClass("on");
      jQuery(this).toggleClass("active");
      jQuery(this)
        .next()
        .toggleClass("on hidden");
      jQuery(this)
        .find("i")
        .toggleClass("fa-minus fa-plus");
    }
  });
}

export default init
